import {faY} from "@fortawesome/free-solid-svg-icons";

export default faY;
